import React, { useState } from "react";
import { Box, Flex, Button, FileInput, Image, Text } from "@mantine/core";
import { uploadImage } from "../../../../services/category";
import { notifications } from "@mantine/notifications";
import { IconCheck, IconX, IconUpload } from "@tabler/icons-react";

const FormEditImage = ({ dataDetail, onCloseModal, reloadList }) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      notifications.show({
        title: "Error",
        message: "Please select an image file",
        color: "red",
        icon: <IconX />,
      });
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);
      
      const res = await uploadImage(dataDetail.id, formData);
      if (res.success || res.message || res.data) {
        notifications.show({
          title: "Success",
          message: "Image updated successfully",
          color: "teal",
          icon: <IconCheck />,
        });
        onCloseModal();
        reloadList();
      }
    } catch (error) {
      console.error("Submit error:", error);
      notifications.show({
        title: "Error",
        message: error?.response?.data?.message || "Failed to update image",
        color: "red",
        icon: <IconX />,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <Box mb="md">
          <Text size="sm" mb="xs" fw={500}>
            Current Image for: {dataDetail?.attributes?.name}
          </Text>

          {dataDetail?.attributes?.image && !file && (
            <Image
              src={dataDetail.attributes.image}
              width={150}
              height={150}
              radius="md"
              fit="cover"
              mb="md"
            />
          )}

          {file && (
            <Image
              src={URL.createObjectURL(file)}
              width={150}
              height={150}
              radius="md"
              fit="cover"
              mb="md"
            />
          )}

          <FileInput
            label="Upload New Image"
            placeholder="Click to browse"
            accept="image/*"
            icon={<IconUpload size={14} />}
            onChange={setFile}
            mb="md"
            withAsterisk
          />
        </Box>

        <Flex justify="flex-end" gap="sm">
          <Button variant="outline" color="gray" onClick={onCloseModal}>
            Cancel
          </Button>
          <Button type="submit" loading={loading}>
            Upload
          </Button>
        </Flex>
      </form>
    </Box>
  );
};

export default FormEditImage;
